import { TableRow as MuiTableRow } from '@mui/material';
import { styled } from '@mui/system';
import colors from '../../../assets/colors';

const TableRow = styled(MuiTableRow, {
  shouldForwardProp: (prop) =>
    prop !== 'dropdown' && prop !== 'dropdownDetails',
})(({ dropdown, dropdownDetails }) => ({
  backgroundColor: colors.rowDark,
  ...(dropdown && {
    '&:nth-of-type(4n-3)': {
      backgroundColor: colors.rowLight,
    },
  }),
  ...(dropdownDetails && {
    '&:nth-of-type(4n-2)': {
      backgroundColor: colors.rowLight,
    },
  }),
  ...(!dropdown &&
    !dropdownDetails && {
      '&:nth-of-type(odd)': {
        backgroundColor: colors.rowLight,
      },
    }),
}));
export default TableRow;
